import React from 'react';

interface Props {
  id: string;
}

export const PrimisAMP: React.FC<Props> = ({ id }) => {
  return (
    <div
      // AMP custom elements are not HTML DOMPurify allows; id is a controlled Primis unit id.
      // oxlint-disable-next-line benzinga/no-unsanitized-innerhtml
      dangerouslySetInnerHTML={{
        __html: `
        <amp-video-iframe
          src="https://live.primis-amp.tech/content/video/amp/videoIframe.php?s=${id}"
          width="16"
          height="9"
          layout="responsive"
          dock="#primis-dock-slot"
          style="overflow: visible;">
        </amp-video-iframe>
        <div style="right: 1px; position: fixed; bottom: 52px;" id="primis-video-amp">
          <amp-layout
            width="213"
            height="120"
            id="primis-dock-slot">
          </amp-layout>
        </div>
      `,
      }}
    />
  );
};
